module.exports = __webpack_public_path__ + "static/media/google_icon.551e3189.png";